import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Preserves the query string (UTMs, etc.) while replacing the path with `to`.
 * Used from `/email/...` onboarding CTA routes — see `routes-with-error-boundaries.tsx`.
 */
export function EmailCtaRedirect({ to }: { readonly to: string }): React.ReactElement {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}
